import useTinyMCE from "components/app/useTinyMCE";
import { useCallback, useRef } from "react";
import { Control, useController } from "react-hook-form";
import { FormHelperText } from "@mui/material";

type TinyMCEControllerProps = {
  control: Control;
  name: string;
  initialValue?: string;
  placeholder?: string;
  required?: boolean;
};

const TinyMCEController = ({
  control,
  name,
  initialValue = "",
  placeholder = "Please add description here",
  required = false,
}: TinyMCEControllerProps) => {
  const initialRef = useRef(initialValue);
  const readyRef = useRef(false);

  const { field, fieldState } = useController({
    control,
    name,
    rules: {
      validate: required
        ? {
            required: (value: string) => {
              const text = value
                ?.replace(/<[^>]*>/g, "")
                .replace(/&nbsp;/g, " ")
                .trim();
              return !!text || "The field is required.";
            },
          }
        : undefined,
    },
  });

  const fieldRef = useRef(field);
  fieldRef.current = field;

  const handleEditorChange = useCallback((newValue: string) => {
    if (readyRef.current) {
      fieldRef.current.onChange(newValue);
    }
  }, []);

  const initPlugin = useCallback((editor: any) => {
    editor.on("init", () => {
      editor.setContent(fieldRef.current.value || "");
      setTimeout(() => {
        if (!editor.removed) {
          editor.getBody().blur();
        }
        readyRef.current = true;
      });
    });
    editor.on("blur", () => {
      fieldRef.current.onBlur();
    });
  }, []);

  const { editor } = useTinyMCE({
    initialValue: initialRef.current,
    value: field.value,
    customPlugins: [initPlugin],
    init: {
      height: 200,
      placeholder: placeholder,
      width: "100%",
    },
    onEditorChange: handleEditorChange,
  });

  return (
    <>
      {editor}
      {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
    </>
  );
};

export default TinyMCEController;
